import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instance26x4wee5nyx6a as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.v3v_1 = 8192;
        this.w3v_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.y3v_1 = 0;
  _this__u8e3s4.z3v_1 = 0;
  _this__u8e3s4.a3w_1 = false;
  _this__u8e3s4.b3w_1 = false;
  _this__u8e3s4.c3w_1 = null;
  _this__u8e3s4.d3w_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static e3w() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.x3v_1 = new Int8Array(8192);
        $this.b3w_1 = true;
        $this.a3w_1 = false;
        return $this;
      }
      static f3w(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.x3v_1 = data;
        $this.y3v_1 = pos;
        $this.z3v_1 = limit;
        $this.a3w_1 = shared;
        $this.b3w_1 = owner;
        return $this;
      }
      g3w() {
        this.a3w_1 = true;
        return Segment().f3w(this.x3v_1, this.y3v_1, this.z3v_1, true, false);
      }
      h3w() {
        var result = !(this.c3w_1 === this) ? this.c3w_1 : null;
        ensureNotNull(this.d3w_1).c3w_1 = this.c3w_1;
        ensureNotNull(this.c3w_1).d3w_1 = this.d3w_1;
        this.c3w_1 = null;
        this.d3w_1 = null;
        return result;
      }
      i3w(segment) {
        segment.d3w_1 = this;
        segment.c3w_1 = this.c3w_1;
        ensureNotNull(this.c3w_1).d3w_1 = segment;
        this.c3w_1 = segment;
        return segment;
      }
      j3w(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.z3v_1 - this.y3v_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().s2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.g3w();
        } else {
          prefix = SegmentPool_instance.m3w();
          var tmp0 = this.x3v_1;
          var tmp2 = prefix.x3v_1;
          var tmp5 = this.y3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.y3v_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.z3v_1 = prefix.y3v_1 + byteCount | 0;
        this.y3v_1 = this.y3v_1 + byteCount | 0;
        ensureNotNull(this.d3w_1).i3w(prefix);
        return prefix;
      }
      n3w() {
        // Inline function 'kotlin.check' call
        if (!!(this.d3w_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.d3w_1).b3w_1)
          return Unit_instance;
        var byteCount = this.z3v_1 - this.y3v_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.d3w_1).z3v_1 | 0) + (ensureNotNull(this.d3w_1).a3w_1 ? 0 : ensureNotNull(this.d3w_1).y3v_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.o3w(ensureNotNull(this.d3w_1), byteCount);
        this.h3w();
        SegmentPool_instance.p3w(this);
      }
      o3w(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.b3w_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.z3v_1 + byteCount | 0) > 8192) {
          if (sink.a3w_1)
            throw IllegalArgumentException().xd();
          if (((sink.z3v_1 + byteCount | 0) - sink.y3v_1 | 0) > 8192)
            throw IllegalArgumentException().xd();
          var tmp0 = sink.x3v_1;
          var tmp2 = sink.x3v_1;
          var tmp5 = sink.y3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.z3v_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.z3v_1 = sink.z3v_1 - sink.y3v_1 | 0;
          sink.y3v_1 = 0;
        }
        var tmp0_0 = this.x3v_1;
        var tmp2_0 = sink.x3v_1;
        var tmp4 = sink.z3v_1;
        var tmp6 = this.y3v_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.y3v_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.z3v_1 = sink.z3v_1 + byteCount | 0;
        this.y3v_1 = this.y3v_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.e3w);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
